import Vue from 'vue';
import VueI18n from 'vue-i18n';
import i18nGlobal from '../../lang/i18n';
import { messages } from '@/core/lang/core.i18n';
import Tools from '../../providers/tools';
import KEYS from '@/values/keys';
import { coursesI18n } from '@/courses/lang/courses.i18n';
import { meetingsI18n } from '@/meetings/lang/meetings.i18n';
import { courseTemplatesI18n } from '@/course-templates/lang/course-templates.i18n';
import { toolsI18n } from '@/tools/lang/tools.i18n';
import { screenMirroringI18n } from '@/screen-mirroring/lang/screen-mirroring.i18n';

Vue.use(VueI18n);

const msg = {
  en: {
    common: i18nGlobal.en.common,
    drawItems: i18nGlobal.en.drawItems,
    errors: i18nGlobal.en.errors,
    footer: i18nGlobal.en.footer,
    meetings: meetingsI18n.en,
    menu: messages.en.menu,
    auth: messages.en.auth,
    calendar: messages.en.calendar,
    language: messages.en.language,
    homeworks: i18nGlobal.en.homeworks,
    teacherPortal: i18nGlobal.en.teacherPortal, 
    courses: coursesI18n.en,
    inactivityTimeout: messages.en.inactivityTimeout,
    courseTemplates: courseTemplatesI18n.en,
    lesson: coursesI18n.en.lesson,
    portal: {
      markAsResolved: 'Mark as resolved',
      dashboard: 'Dashboard',
      filterBy: 'Filter by:',
      review: 'Review:',
      redo: 'Redo',
      selectOneStudent: 'Select one student',
      noInternet: 'No internet connection',
    },
    myContent: {
      gridView: 'Grid view',
      listView: 'List view',
      coursesInDrafts: 'Courses in drafts',
      booksInDrafts: 'Books in drafts',
      confirmRemoveDraft: 'Are you sure you want to delete this subject?',
      booksPurchased: 'Books purchased',
      coursesPurchased: 'Courses purchased',
      notItemsSection: 'You don\'t have content in this section for the moment',
      view: 'View',
      editContent: 'Edit content',
      editProduct: 'Edit product',
      removeDraft: 'Delete draft',
      download: 'Download',
      cover: 'Cover',
      title: 'Title',
      teacher: 'Teacher',
      subject: 'Subject',
      actions: 'Actions'
    },
    viewer: {
      openInNewWindow: 'Open in a new window',
      noContent: 'No content',
      openInCourse: 'Open section of the course',
      interactiveActivity: 'Interactive Activity',
      response: 'Response'
    },
    tools: toolsI18n.en,
    screenMirroring: screenMirroringI18n.en,
  },
  es: {
    common: i18nGlobal.es.common,
    drawItems: i18nGlobal.es.drawItems,
    errors: i18nGlobal.es.errors,
    footer: i18nGlobal.es.footer,
    meetings: meetingsI18n.es,
    menu: messages.es.menu,
    auth: messages.es.auth,
    calendar: messages.es.calendar,
    language: messages.es.language,
    homeworks: i18nGlobal.es.homeworks,
    teacherPortal: i18nGlobal.es.teacherPortal, 
    courses: coursesI18n.es,
    inactivityTimeout: messages.es.inactivityTimeout,
    courseTemplates: courseTemplatesI18n.es,
    lesson: coursesI18n.es.lesson,
    portal: {
      markAsResolved: 'Marcar como resuelto',
      dashboard: 'Tablero',
      filterBy: 'Filtrar por:',
      review: 'Revisar:',
      redo: 'Rehacer',
      selectOneStudent: 'Selecciona un estudiante',
      noInternet: 'No hay conexión a internet'
    },
    myContent: {
      gridView: 'Vista de cuadrícula',
      listView: 'Vista de lista',
      coursesInDrafts: 'Cursos en borrador',
      booksInDrafts: 'Libros en borrador',
      confirmRemoveDraft: '¿Está seguro que quiere eliminar este borrador?',
      booksPurchased: 'Libros comprados',
      coursesPurchased: 'Cursos comprados',
      notItemsSection: 'No posees contenido en esta sección por el momento',
      view: 'Ver',
      editContent: 'Editar contenido',
      editProduct: 'Editar producto',
      removeDraft: 'Eliminar borrador',
      download: 'Descargar',
      cover: 'Portada',
      title: 'Título',
      teacher: 'Profesor',
      subject: 'Tema',
      actions: 'Acciones'
    },
    viewer: {
      openInNewWindow: 'Abrir en una nueva ventana',
      noContent: 'No hay contenido',
      openInCourse: 'Abrir sección en el curso',
      interactiveActivity: 'Tarea',
      response: 'Respuesta'
    },
    tools: toolsI18n.es,
    screenMirroring: screenMirroringI18n.es,
  }
};

const local = Tools.getCookie(KEYS.LANGUAGE_COOKIE);
const locale = local ? local : 'en';
const i18n = new VueI18n({
  locale: locale,
  messages: msg
});

export default i18n;
